import cn from 'classnames';
import { type ComponentPropsWithoutRef } from 'react';

export function Footer({ className, ...props }: ComponentPropsWithoutRef<'footer'>) {
    return <footer className={cn('side-drawer__footer', className)} {...props} />;
}
